// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const eventApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: (queryParams = {}) => {
        let _queryParams = {...queryParams};
        if (queryParams?.provider_ids) {
          _queryParams.provider_ids = queryParams.provider_ids.join(',');
        }
        const qs = new URLSearchParams(_queryParams).toString();
        return `event/?${qs}`;
      },
      providesTags: ['Event', 'VacationTime'],
    }),
    createEvent: builder.mutation({
      query: body => ({
        url: 'event/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Event', 'VacationTime'],
    }),
    updateEvent: builder.mutation({
      query: ({ id, body }) => ({
        url: `event/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['Event', 'VacationTime'],
    }),
    removeEvent: builder.mutation({
      query: ({ id }) => ({
        url: `event/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Event', 'VacationTime'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetEventsQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useRemoveEventMutation
} = eventApi;
